import { menusStateType } from "reducer/types";

  export const SET_MENUS_STATE = (payload: menusStateType) => ({
    type: 'SET_MENUS_STATE',
    payload: payload
  });  


  export const SET_OPEN_ITEM = (payload: string) => ({
    type: 'SET_OPEN_ITEM',
    payload: payload
  });  


  

  

   
  
  
  